import React from 'react';

import Home from './Home';
import {PATHS} from '../components/Footer';

const UsernameLogin = props => (
  <Home
    {...props}
    mode={{
      header: [PATHS.LOGIN_BY_SOCIALS],
      primarySocials: false,
      username: true,
      secondarySocials: false,
      footer: [PATHS.FORGOT_PASSWORD, PATHS.CREATE_ACCOUNT]
    }}
    showRememberMe={false}
  />
);

export default UsernameLogin;



// WEBPACK FOOTER //
// ./pages/UsernameLogin.jsx